import { getErrorMessage } from 'helpers/errorMsg'
import { logOpenTelemetryApiError } from 'utils/helpers/openTelemetryLog'

const APP_DOMAIN = 'web-admin'
const APP_PAGE_ATTRIBUTE = 'app.page'
const knownInsufficientStockPatterns = [
  /insufficient\s+reserved\s+quantity/i,
  /insufficient\s+inventory\s+detail\s+quantity/i,
  /reserve\s+stock\s+inventory\s+detail/i,
]
const productIdPatterns = [
  /\bproduct\s+id\s*(?::|#)?\s*(\d+)\b/i,
  /\buntuk\s+id\s*(?::|#)?\s*(\d+)\b/i,
]
const locationIdPattern = /\blocation\s+id\s*(?::|#)?\s*(\d+)\b/i

export type InsufficientStockErrorDetailsType = {
  locationId?: string
  productId: string
}

export type LogInsufficientStockApiErrorPayloadType = {
  action: string
  error: unknown
  orderId?: number | string
  page?: string
}

export const parseInsufficientStockErrorMessage = (
  message: string,
): InsufficientStockErrorDetailsType | null => {
  const isKnownError = knownInsufficientStockPatterns.some((pattern) => pattern.test(message))
  if (!isKnownError) {
    return null
  }

  const productId = productIdPatterns.map((pattern) => message.match(pattern)?.[1]).find(Boolean)

  if (!productId) {
    return null
  }

  return {
    locationId: message.match(locationIdPattern)?.[1],
    productId,
  }
}

export const logInsufficientStockApiError = ({
  action,
  error,
  orderId,
  page,
}: LogInsufficientStockApiErrorPayloadType) => {
  if (!orderId || !page) {
    return false
  }

  const message = getErrorMessage(error)
  const details = parseInsufficientStockErrorMessage(message)

  if (!details) {
    return false
  }

  logOpenTelemetryApiError({
    action,
    attributes: {
      [APP_PAGE_ATTRIBUTE]: page,
      location_id: details.locationId,
      order_id: String(orderId),
      product_id: details.productId,
    },
    domain: APP_DOMAIN,
    error,
    message,
  })

  return true
}
